import React from "react";
import { Star } from "lucide-react";

/** Insignia compacta para el muro y los chats. */
export const StarBadge = ({ level, className = "" }) => {
  if (!level) return null;
  const earned = level.stars >= 2;
  return (
    <span data-testid={`star-badge-${level.stars}`}
      title={`${level.name} · ${level.stars}/5 estrellas`}
      className={`inline-flex items-center gap-0.5 text-[10px] leading-none px-1.5 py-0.5 rounded-full border ${
        earned ? "border-amber-300/25 bg-amber-300/10 text-amber-200"
               : "border-white/10 bg-white/5 text-white/45"
      } ${className}`}>
      <Star className={`w-2.5 h-2.5 ${earned ? "fill-amber-300 text-amber-300" : "fill-white/35 text-white/35"}`} />
      {level.stars}
    </span>
  );
};

/** Nivel del miembro: 5 estrellas que se llenan con amigos + seguidores. */
export const Stars = ({ level, size = 14, showName = true }) => {
  if (!level) return null;
  return (
    <div className="flex items-center gap-1.5" data-testid="profile-level"
      title={level.next_at ? `${level.score} de ${level.next_at} para la siguiente estrella` : "Nivel máximo"}>
      <div className="flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map((i) => (
          <Star key={i} style={{ width: size, height: size }}
            className={i <= level.stars ? "text-amber-300 fill-amber-300" : "text-white/20"} />
        ))}
      </div>
      {showName && (
        <span className="text-[11px] uppercase tracking-[0.12em] text-amber-200/80">
          {level.name}
        </span>
      )}
    </div>
  );
};

export default Stars;
